import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CepService {
  private readonly baseUrl = 'https://viacep.com.br/ws';

  constructor(private http: HttpClient) {}

  /**
   * Consulta um CEP na API ViaCEP
   * @param cep CEP a ser consultado (pode conter traço e ponto)
   * @returns Observable com os dados do endereço ou null se não encontrado
   */
  consultaCep(cep: string): Observable<ViaCepResponse | null> {
    // Remove caracteres não numéricos
    cep = cep.replace(/\D/g, '');
    
    if (cep === '' || cep.length !== 8) {
      return of(null);
    }

    // Incluir timeout para garantir resposta rápida
    return this.http.get<ViaCepResponse>(`${this.baseUrl}/${cep}/json`, { 
      responseType: 'json',
      observe: 'body'
    }).pipe(
      map(response => {
        if (response.erro) {
          return null;
        }
        return response;
      }),
      catchError(error => {
        console.error('Erro ao consultar CEP:', error);
        return of(null);
      })
    );
  }
}